export const CALCULATION_MLB = 'CalculationMLB';
export const MLB = 'MLB';
export const MONTHLY = 'MONTHLY';
export const DAYS = 'days';
export const PERCENTAGE_35 = 'PERCENTAGE_35';
export const OUTPUT_FORMAT = 'YYYY-MM-DD';
export const INPUT_FORMAT = 'DD-MM-YYYY';

export const DEFAULT_DISABILITY_DURATION = {
  valueField: 'INSURANCE_END_DATE',
};
export const DEFAULT_CLAIM_ASSESSMENT = {
  valueField: 'FITTING_LABOUR',
};
export const DEFAULT_PAYMENT_LEVEL = {
  valueField: 'PRO_RATA',
};
export const DEFAULT_WAITING_PERIOD = {
  valueField: 'DAYS_365',
};
export const DEFAULT_UNEMPLOYMENT_DURATION = {
  valueField: 'YEARS_2',
};
